export default __webpack_public_path__ + "static/media/transparent.aeb5ae55.svg";